import React from 'react';
import { Router } from '@reach/router';
import {
    IonApp,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonSplitPane,
    IonMenu,
    IonList,
    IonMenuToggle,
    IonItem,
    IonLabel,
    IonIcon,
    IonPage
} from '@ionic/react';
import {
    // list,
    logoGameControllerA,
    chatboxes
} from 'ionicons/icons';
// import ListPage from './pages/List';
import HomePage from './pages/Home';
import GamePage from './pages/Game';
import ProfilePage from './pages/Profile';


import './index.css';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';
/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';
/* Theme variables */
import './theme/variables.css';

const App = () => {
    const appPages = [
        // {
        //     title: 'List',
        //     url: '/list',
        //     icon: list
        // },
        {
            title: 'Tic Tac Toe',
            url: '/tic-tac-toe',
            icon: logoGameControllerA
        },
        {
            title: 'Profile',
            url: '/profile',
            icon: chatboxes
        }
    ];

    return (
        <IonApp>
            <IonSplitPane contentId="main">
                <IonMenu contentId="main" type="overlay">
                    <IonHeader>
                        <IonToolbar>
                            <IonTitle>anlex N</IonTitle>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent>
                        <IonList>
                            {appPages.map((appPage, index) => (
                                <IonMenuToggle key={index} autoHide={false}>
                                    <IonItem href={appPage.url}>
                                        <IonIcon slot="start" icon={appPage.icon} />
                                        <IonLabel>{appPage.title}</IonLabel>
                                    </IonItem>
                                </IonMenuToggle>
                            ))}
                        </IonList>
                    </IonContent>
                </IonMenu>

                <IonPage id="main">
                    <Router>
                        <HomePage path="/" />
                        {/* <ListPage path="/list" /> */}
                        <GamePage path="/tic-tac-toe" />
                        <ProfilePage path="/profile" />
                    </Router>
                </IonPage>
            </IonSplitPane>
        </IonApp>

    );

}

export default App;